import { useSelector } from 'react-redux';

const useLoginFlowState = () => {
    const tfaState = useSelector(state => state.authenticateReducer.tfaState);
    const authModeState = useSelector(state => state.authenticateReducer.authModeState);
    const eulaState = useSelector(state => state.authenticateReducer.eulaState);
    const globalIdTransition = useSelector(state => state.authenticateReducer.globalIdTransition);
    const MAX_SESSIONS_EXCEED = useSelector(state => state.authenticateReducer.MAX_SESSIONS_EXCEED);
    const isPasswordExpired = useSelector(state => state.authenticateReducer.isPasswordExpired);
    const SAVED_AUTH_PARAM = useSelector(state => state.authenticateReducer.SAVED_AUTH_PARAM);
    const errorMessage = useSelector(state => state.authenticateReducer.errorMessage);
    const webauthnDetails = useSelector(state => state.authenticateReducer.webauthnDetails);
    const authenticationParameters = useSelector(state => state.authenticateReducer.authenticationParameters);

    return {
        ERR_REQUIRES_TFA: tfaState.required,
        ERR_REQUIRES_PASSWORD_LESS_OTP: authModeState.requiresPasswordLessOtp,
        ERR_REQUIRES_PASSWORD: authModeState.requiresPassword,
        ERR_REQUIRES_EULA: false,
        globalIdTransition,
        transitionToGlobalIdToken: globalIdTransition.token,
        tfaPrompt: tfaState.prompt,
        tfaWebAuthnRequest: tfaState.webAuthnRequest,
        EULA_DOC: eulaState.eulaDoc,
        MAX_SESSIONS_EXCEED,
        isPasswordExpired,
        TFA_IS_WEBAUTHN_REGISTERED: tfaState.isWebAuthnRegistered,
        TFA_IS_TFA_DEVICE_REGISTERED: tfaState.isTfaDeviceRegistered,
        TFA_USE_OVERRIDE: tfaState.useOverride,
        SAVED_AUTH_PARAM,
        errorMessage,
        popupEula: eulaState.popupEula,
        webauthnDetails,
        authenticationParameters,
    };
};

export default useLoginFlowState;
